module.exports = __webpack_public_path__ + "static/media/zip.17b541d8.svg";